module.exports = __webpack_public_path__ + "img/By-name (1).9e218ebe.png";